(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-accordion"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-accordion-trigger]');
    if (!trigger) return;

    const keyword = trigger.getAttribute('data-accordion-trigger');
    const accordions = document.querySelectorAll('accordion-custom');

    for (const accordion of accordions) {
      const summary = accordion.querySelector('summary');
      if (summary && summary.textContent.includes(keyword)) {
        const details = accordion.querySelector('details');
        if (details) {
          details.open = true;
          accordion.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        break;
      }
    }
  });
  } catch(e) { console.error(e); }
})();

})();
